import Service from "../service";
import AuthService from "../AuthService";

const Organization = {
  saveOrganization(data) {
    return AuthService.post('/api/save-organization', data);
  },
  showOrganization(page) {
    return Service.get('/api/get-organization?page='+page);
  },
  getOrganizationEdit(id) {
    return AuthService.get(`/api/get-organization-edit/${id}`)
  },
  editOrganization(id,data) {
    return AuthService.post(`/api/edit-orgnization/${id}`, data)
  },
  deleteOrganization(id) {
    return AuthService.post(`/api/delete-organization/${id}`)
  }
};

export default Organization;
